// extracted by mini-css-extract-plugin
module.exports = {"controls":"ImageBlock_controls__36bZy","image":"ImageBlock_image__STn3r","root":"ImageBlock_root__CCLu5"};